"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconLink = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_icon_1 = require("../icons/app_icon");
const IconLink = ({ href, iconName }) => {
    return ((0, jsx_runtime_1.jsx)("a", Object.assign({ href: href }, { children: (0, jsx_runtime_1.jsx)(app_icon_1.AppIcon, { name: iconName }) })));
};
exports.IconLink = IconLink;
//# sourceMappingURL=icon_link.js.map